export default __webpack_public_path__ + "media/salad_banner_en.f4f938e6.png";